/**
 * Serializa dados para dentro de uma tag <script type="application/ld+json">.
 *
 * JSON.stringify sozinho NÃO é seguro nesse contexto: um texto vindo do editor
 * (título, descrição, autor, FAQ) que contenha `</script>` fecharia a tag e o
 * resto viraria HTML executável. Escapamos `<`, `>` e `&` em escapes unicode
 * (válidos em JSON e lidos igual pelos buscadores), além dos separadores de
 * linha U+2028/U+2029.
 */
export function jsonLd(data: unknown): string {
  return JSON.stringify(data)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}
